/** The id `SkipToContent` targets; the app layout applies it to <main>. */
export const MAIN_CONTENT_ID = 'main-content';

/**
 * Skip link.
 *
 * A keyboard user would otherwise have to tab through the entire navigation on
 * every page load to reach the content. The link stays visually hidden until
 * focused, so it costs nothing for pointer users. WCAG 2.4.1.
 */
export function SkipToContent() {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only-focusable bg-primary text-primary-foreground focus-visible:ring-ring absolute top-4 left-4 z-50 rounded-md px-4 py-2 text-sm font-medium shadow-lg focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
    >
      Skip to main content
    </a>
  );
}
